import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Table, Row, Col, Space, Spin, Button } from "antd";
import { SendOutlined, PrinterOutlined } from "@ant-design/icons";
import { quotationService } from "../../../services";
import { changeDocumentTitle } from "../../../utils/title";

function QuotationView() {
  const { id } = useParams();
  const [quotations, setQuotations] = useState([]);
  const [userQuotation, setuserQuotation] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });

  const columns = [
    {
      title: "S.No",
      dataIndex: "SNo",
      key: "SNo",
      render: (text, record, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
    },
    {
      title: "Destination",
      dataIndex: "destination",
      key: "Destination",
      render: (text) => text.toUpperCase()
    },
    {
      title: "Container",
      dataIndex: "containersize",
      key: "Container",
    },
    {
      title: "No Of Vehicles",
      dataIndex: "no_of_vehicles",
      key: "NoOfVehicles",
    },
    {
      title: "Vehicle Type",
      dataIndex: "vehicle_type",
      key: "VehicleType",
    },
    {
      title: "Loading Charges",
      dataIndex: "loading_charges",
      key: "LoadingCharges",
    },
  ];

  const handleDownload = () => {
    const printContent = document.getElementById("printableDiv").innerHTML;
    const originalContent = document.body.innerHTML;

    // Add print-specific styles
    document.body.innerHTML = `
      <style>
        @media print {
          body {
            font-size: 20px; /* Base font size */
            line-height: 1.6;
            padding: 0;
          }
          h3 {
            font-size: 50px !important;
            font-weight: bold;
          }
          .top-section {
            margin-bottom: 20px;
          }
          ul {
            font-size: 20px;
            margin-bottom: 20px;
            line-height: 1.8;
          }
          li {
            margin: 5px;
          }
          .table-div {
            margin-left: 0px !important;
          }
          .ant-table {
            font-size: 20px;
          }
          .ant-table-thead > tr > th {
          font-size: 20px;
          padding: 14px;
          background-color: #f0f0f0;
        }
        .ant-table-tbody > tr > td {
          font-size: 20px;
          padding: 14px;
        }
        }
      </style>
      <div id="printableDiv">${printContent}</div>
    `;

    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload(); // Restore state and events
  };


  const initialize = async () => {
    setLoading(true);
    const { success, data } = await quotationService.view(id);
    if (success) {
      setQuotations(data.details);
      setuserQuotation(data.userQuotation);
    }
    setLoading(false);
  };

  useEffect(() => {
    changeDocumentTitle("Quotation");
    initialize();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center">
        <Spin spinning={loading} size={"large"} tip="Loading..." />
      </div>
    );
  }
  return (
    <div
      id="printableDiv"
      style={{
        padding: "15px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >
      {/* Header Content */}
      <Row gutter={16}>
        <Col span={20}>
          <div className="top-section">

            <h3 style={{ fontWeight: "bold" }}>Hello {userQuotation.name},</h3>
            <ul style={{ lineHeight: "1.8", margin: 0 }}>
              <li>LOADING/FREIGHT RATES ARE AS ATTACHED.</li>
              <li>
                ABOVE RATES INCLUSIVE OF {quotations[0]?.chasis_days} DAYS CHASIS CHARGES; THEREAFTER ${quotations[0]?.chasis_charges}/DAY
                PER CHASIS.
              </li>
              <li>PAYMENT TERMS: 7 DAYS FROM THE DATE OF INVOICE.</li>
              <li>
                LOADING PICTURES WILL BE PROVIDED TO SATISFY THE CUSTOMERS IN
                ADVANCE.
              </li>
              <li>
                CHEQUE BOOK PROVIDED FOR ISSUANCE OF CHEQUES TO CUSTOMERS WITH
                THEIR OWN DISPATCH.
              </li>
              <li>DEDICATED CUSTOMER SERVICE FOR VOLUMETRIC CUSTOMERS.</li>
              <li>STORAGE POLICY: {quotations[0]?.storage_days} DAYS FREE; THEREAFTER ${quotations[0]?.storage_charges}/DAY PER UNIT.</li>
              <li>
                DRIVERS MUST CONTACT PRIOR TO DELIVERY OR EMAIL THE DISPATCH
                SHEETS FOR PROPER DELIVERY AND NO DELAYS.
              </li>
              <li>ADVANCE BOOKINGS BASED ON VOLUME COMMITMENT.</li>
              <li>7 ACRES OF PARKING SPACE.</li>
              <li>
                WE REQUEST THAT THE LOADING PLAN BE SENT 48 TO 72 BUSINESS HOURS
                IN ADVANCE OF FIRST RECEIVING.
              </li>
              <li>
                IF CUSTOMERS NEED TO PICK UP VEHICLES, IT WILL BE SUBJECT TO $100
                PER VEHICLE, ALONG WITH STORAGE CHARGES AFTER 30 DAYS OF RECEIVING
                AT THE FACILITY.
              </li>
              <li>
                IN-HOUSE DRAYAGE NETWORK WITH OWN CHASIS FOR SMOOTH OPERATIONS.
              </li>
            </ul>
          </div>
        </Col>
      </Row>

      <div
        className="table-div"
        style={{
          padding: "20px",
          border: "1px solid #ccc",
          borderRadius: "8px",
          marginTop: "20px",
        }}
      >
        <Table
          columns={columns}
          scroll={{ x: "max-content" }}
          dataSource={quotations}
          loading={loading}
          pagination={false}
        />
      </div>

      <div style={{ textAlign: "right", marginTop: "20px" }} className="no-print">
        <Space size="large">
          <Button type="primary">
            <a href="mailto: ">
              <SendOutlined style={{ fontSize: "18px", cursor: "pointer" }} />
            </a>
          </Button>
          <Button type="primary" onClick={handleDownload}>
            <PrinterOutlined style={{ fontSize: "18px", cursor: "pointer" }} />
          </Button>
        </Space>
      </div>
    </div>
  );
}
export default QuotationView;
